import { handleAuthenticationCallback } from "@/legacy/redux";
import LoadingSpinner from "@imminently/decisively-ui/LoadingSpinner";
import { Card, Typography } from "@mui/material";
import { parse } from "qs";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";

const useAuthState = () => {
  const dispatch = useDispatch();

  const { error, error_description, code } = parse(useLocation().search, { ignoreQueryPrefix: true });
  const {
    id_token,
    access_token,
    refresh_token,
    code: hash_code,
  } = parse(useLocation().hash, { ignoreQueryPrefix: true, delimiter: /[#&]/ });
  console.log("[Authcallback]", {
    hasCode: Boolean(code || hash_code),
    hasError: Boolean(error),
  });

  useEffect(() => {
    if (!error) {
      dispatch(
        handleAuthenticationCallback({
          accessToken: access_token,
          idToken: id_token,
          refreshToken: refresh_token,
          code,
          hash_code,
        }),
      );
    }
  }, [error]);

  return { error, error_description };
};

const Authcallback = () => {
  const { error, error_description } = useAuthState();

  if (error) {
    return (
      <Card className="flex flex-col items-center gap-4 px-16 py-8">
        <Typography
          component="h1"
          variant="h1"
          align="center"
          gutterBottom
        >
          Error
        </Typography>
        <Typography
          variant="body1"
          align="center"
          gutterBottom
        >
          {error_description?.toString()}
        </Typography>
      </Card>
    );
  }

  return (
    <Card className="flex flex-col items-center gap-4 px-16 py-8">
      <Typography
        component="h1"
        variant="h1"
        align="center"
        gutterBottom
      >
        Signing in
      </Typography>
      <Typography
        variant="body1"
        align="center"
        gutterBottom
      >
        You will be redirected to the application shortly.
      </Typography>
      <LoadingSpinner size="sm" />
    </Card>
  );
};

export default Authcallback;
